function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
import { isPlainObject, isString } from "lodash/fp";
import { theme } from "./theme";
export function isNessiePropTypeValidatorSingleProp(value) {
  return !!value && typeof value === "function";
} // -----------------
// Responsive nessie prop type
// For now responsive props  are experimental, we want to warn the users about it.
//

function responsiveNessiePropType(props, prop, displayName) {
  var propValue = props[prop];
  if (propValue === undefined) return;
  if (isPlainObject(propValue) && !props._dangerouslyAllowResponsiveProps) {
    var error = new Error("Experimental responsive prop used. Please add the prop _dangerouslyAllowResponsiveProps is you wish to use  the experimental responsive API. You can read more about it here https://components.classdojo.com/nessie/#/#responsive");
    return Object.assign(error, {
      title: "Experimental responsive prop used",
      description: "\n        Responsive props are still experimental, if you want to use them please add the prop <strong>_dangerouslyAllowResponsiveProps</strong>\n        so we can easily spot the emerging patterns and reassess in upcoming releases whether we stick to this API or a different one.\n        </br>\n        Component <strong>'".concat(displayName, "'</strong>\n        </br>\n        You can read  more here ").concat(getStringLink("https://components.classdojo.com/nessie/#/#responsive"), "\n      ")
    });
  }
}
export function oneOfNessieResponsivePropType(types) {
  return function (props, prop, displayName) {
    var propValue = props[prop];
    if (propValue === undefined) return; // If is a responsive prop type then lets validate by the responsive validator and skip the validation here
    // TODO: Would be nice to validate the individual responsive values but for now responsive api is experimental,
    // we will revisit later.

    if (isPlainObject(propValue)) {
      return responsiveNessiePropType(props, prop, displayName);
    }
    if (!types.includes(propValue)) {
      var error = new Error("One of these values was expected '[".concat(types.join(", "), "] but instead got '").concat(propValue, "'"));
      return Object.assign(error, {
        title: "Wrong prop value provided. Check possible types",
        description: "\n        Prop <strong>".concat(prop, "</strong> can only take one of the following values <strong>[").concat(types.join(", "), "]</strong>.\n        Instead we got <strong>'").concat(propValue, "'</strong>\n        </br>\n        Component <strong>'").concat(displayName, "'</strong>\n      ")
      });
    }
  };
} // ------------------
// Spacing Prop Type
//

export function spacingNessieResponsivePropType(props, prop, displayName) {
  var propValue = props[prop];
  if (propValue === undefined) return; // If is a responsive prop type then lets validate by the responsive validator and skip the validation here
  // TODO: Would be nice to validate the individual responsive values but for now responsive api is experimental,
  // we will revisit later.

  if (isPlainObject(propValue)) {
    return responsiveNessiePropType(props, prop, displayName);
  } // const isSpacingProp = SPACING_PROPS.includes(prop);
  // if (!isSpacingProp) return;

  if (props._dangerouslyAllowCustomSpacing) return;
  var isNotASpaceFromTheme = !ALLOWED_SPACE_VALUES.includes("".concat(propValue));
  if (isNotASpaceFromTheme) {
    var error = new Error("Spacing prop error. Please use one of the space values from our theme");
    return Object.assign(error, {
      title: "Spacing prop error",
      description: "\n        You are trying to hardcode a space unit with pixels or other non supported values.\n        We encourage using a value of spacing from our theme.\n        Check more here ".concat(getStringLink("https://components.classdojo.com/nessie/#/spacing"), "\n        </br></br>\n        The error was found on the prop <strong>'").concat(prop, "'</strong>, where you used the value <strong>'").concat(propValue, "'</strong>.\n        On the component <strong>'").concat(displayName, "'</strong>\n        </br>\n        Allowed space values: <strong>[").concat(ALLOWED_SPACE_VALUES.join(" ,"), "]</strong>\n        </br>\n        If this is a case that you consider is not well supported by nessie-web then you can opt-in to use hardcoded values.\n        To do so add the prop <strong>_dangerouslyAllowCustomSpacing</strong> to the component.\n      ")
    });
  }
} // ---------
// Color Prop Type
//

export function colorNessieResponsivePropType(props, prop, displayName) {
  var propValue = props[prop];
  if (propValue === undefined) return; // If is a responsive prop type then lets validate by the responsive validator and skip the validation here
  // TODO: Would be nice to validate the individual responsive values but for now responsive api is experimental,
  // we will revisit later.

  if (isPlainObject(propValue)) {
    return responsiveNessiePropType(props, prop, displayName);
  }
  var isColorProp = COLOR_PROPS.includes(prop);
  var themeColors = Object.keys(theme.colors);
  if (!isColorProp) return;
  if (props._dangerouslyAllowCustomColors) return;
  var isNotFromTheme = !themeColors.includes(propValue);
  if (isNotFromTheme) {
    var error = new Error("Color prop error. Please use a color from our theme");
    return Object.assign(error, {
      title: "Color prop error",
      description: "\n        You are trying to set a hardcoded color rather than using one from our palette.\n        We encourage you use a value from our theme.\n        The error was found on the prop <strong>'".concat(prop, "'</strong>, where you used the value\n        <strong>'").concat(propValue, "'</strong>. We highlighted on red the responsible component <strong>'").concat(displayName, "'</strong>\n        </br></br>\n        These are the supported values: ").concat(getStringThemeColors(), "\n        </br>\n        Check more here ").concat(getStringLink("https://components.classdojo.com/nessie/#/palette"), "\n        </br>\n        If this is a case that you consider is not well supported by nessie-web then you can opt-in\n        to use hardcoded values.\n        To do so add the prop <strong>_dangerouslyAllowCustomColors</strong> to the component.\n      ")
    });
  }
}
export function stringNessieResponsivePropType(props, prop, displayName) {
  var propValue = props[prop]; // If is a responsive prop type then lets validate by the responsive validator and skip the validation here
  // TODO: Would be nice to validate the individual responsive values but for now responsive api is experimental,
  // we will revisit later.

  if (isPlainObject(propValue)) {
    return responsiveNessiePropType(props, prop, displayName);
  }
  if (!isString(propValue)) {
    var description = "Expected string on prop '".concat(prop, "', but got value '").concat(propValue, "' of type '").concat(_typeof(propValue), "'. On component <strong>'").concat(displayName, "'</strong>");
    var error = new Error(description);
    return Object.assign(error, {
      title: "Prop of wrong type provided",
      description: description
    });
  }
} // ----------------------------
// Helpers
//

var getStringThemeColors = function getStringThemeColors() {
  var colors = Object.keys(theme.colors).map(function (color) {
    return "\n    <div style=\"display:flex;align-items:center;padding: 3px\">\n    <span style=\"display: inline-block;margin-right: 2px;border: 1px solid gray;border-radius: 50%;width: 20px; height: 20px; background-color: ".concat(theme.colors[color], "\"></span>\n    <strong style=\"display: inline-block\">").concat(color, "</strong></div>\n    ");
  });
  return "<div style=\"display: flex;flex-wrap: wrap\">".concat(colors.join(" "), "</div>");
};
var getStringLink = function getStringLink(link) {
  return "<a style=\"color: black\" href=\"".concat(link, "\" target=\"blank\">").concat(link, "</a>");
};
var COLOR_PROPS = ["color", "borderColor", "backgroundColor"];
var ALLOWED_SPACE_VALUES = ["0", "xxs", "xs", "s", "m", "l", "xl", "xxl", "auto", "dt_xxs", "dt_xs", "dt_s", "dt_m", "dt_l", "dt_xl", "dt_xxl"];